import { logger } from '@/utils/log';
import { EVENT_TYPES, on as emitterOn } from '@/utils/event-emitter.js';
import { enableErrorMessageTrackingInOPC } from '@/common/constants';
import EventTracking from '@/aspects/trackings';
// import { only } from './message-monitor-for-ZVA.js';

// const REQUIRED_MESSAGE_KEYS = ['message'];

const REQUIRED_MESSAGE_TYPE_KEYS = ['error', 'alert'];

const log = (...data) => {
  logger.info('error message tracking', ...data);
}

if (enableErrorMessageTrackingInOPC) {
  log('emit on, initing!');
  emitterOn(EVENT_TYPES.UI_MESSAGE, (data) => {
    if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
      log(EVENT_TYPES.UI_MESSAGE, data);
      EventTracking.triggerUIError(`popup error - ${data.message} - impression`);
    }
  });

  emitterOn(EVENT_TYPES.UI_MESSAGE_CLICK_CLOSE, (data) => {
    if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
      log(EVENT_TYPES.UI_MESSAGE_CLICK_CLOSE, data);
      EventTracking.triggerUIError(`popup error - ${data.message} - close`);
    }
  });

   emitterOn(EVENT_TYPES.UI_MESSAGE_CLICK_LINK, (data) => {
    if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
      log(EVENT_TYPES.UI_MESSAGE_CLICK_LINK, data);
      EventTracking.triggerUIError(`popup error - ${data.message} - ${data.linkText}`);
    }
  });

  emitterOn(EVENT_TYPES.UI_ALERT, (data) => {
    if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
      log(EVENT_TYPES.UI_ALERT, data);
      EventTracking.triggerUIError(`alert error - ${data.message.join(' ')} - impression`);
    }
  });

  emitterOn(EVENT_TYPES.UI_GLOBAL_ALERT, (data) => {
    if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
      log(EVENT_TYPES.UI_GLOBAL_ALERT, data);
      EventTracking.triggerUIError(`message box error - ${data.message.join(' ')} - impression`);
    }
  });

  emitterOn(EVENT_TYPES.UI_GLOBAL_ALERT_CLICK_CTA, (data) => {
    if (REQUIRED_MESSAGE_TYPE_KEYS.includes(data.type)) {
      log(EVENT_TYPES.UI_GLOBAL_ALERT_CLICK_CTA, data);
      EventTracking.triggerUIError(`message box error - ${data.message.join(' ')} - ${data.ctaText}`);
    }
  });
}


